import script from "./NotesComponentBox.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesComponentBox.vue?vue&type=script&setup=true&lang=js"

import "./NotesComponentBox.vue?vue&type=style&index=0&id=1f315836&scoped=true&lang=css"

import exportComponent from "E:\\GCM3\\Demo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f315836"]])

export default __exports__